import { useState } from 'react'
import { Button, Alert } from 'reactstrap'
import { getToken } from '../../utils'
import { FaFileExcel } from 'react-icons/fa'

export default function CSVLink({ url }) {
  console.log('CSVLink rendered')

  const [errors, setErrors] = useState()

  function handleClick() {
    console.log('CSVLink clicked...')
    function tokenSuccess(jwt) {
      console.log(jwt)
      const link = document.createElement('a')
      document.body.appendChild(link)

      const delimiter = url.indexOf('?') > -1 ? '&' : '?'
      link.href = `${url}${delimiter}jwt=${jwt}`
      link.setAttribute('type', 'hidden')
      link.setAttribute('target', '_blank')
      link.click()
    }
    function tokenError(error) {
      console.log('CSVLink: ', JSON.stringify(error))
      setErrors(error)
    }
    getToken(tokenSuccess, tokenError)
  }

  if (errors) {
    <Alert color="danger">{errors}</Alert>
  }
  return (
    <Button data-cy='csv-link' className="csv-link" color="primary" onClick={handleClick}><FaFileExcel /> Export to Spreadsheet</Button>
  )
}
